<template>
  <b-form-group
    label-class="mb-0 label-title"
    :label="item.title"
    label-for="dropdown-form__item"
    :description="item.helpText"
  >
    <v-select
      v-model="item.value"
      :options="options || item.values"
      :disabled="item.disabled"
      :searchable="true"
      :clearable="false"
      :class="{ saving: saving, saved: saved, 'form-dropdown': true }"
      placeholder="-- Please Select --"
      @input="valueChanged"
    ></v-select>
  </b-form-group>
</template>

<script>
import FormItem from "./FormItem";
import vSelect from "vue-select";
import { debounce } from "lodash";
import { EventBus } from "../../event-bus";

export default {
  name: "DropdownFormItem",
  extends: FormItem,
  components: {
    vSelect,
  },
  props: ["item", "options"],
  data() {
    return {
      saving: false,
      saved: false,
    };
  },
  created() {
    this.debouncedSave = debounce(() => {
      this.saved = true;
      this.saving = false;
      setTimeout(() => {
        this.saved = false;
      }, 1000);
    }, 1000);
  },
  mounted() {
    // Auto-select if there's only one option
    const availableOptions = this.options || this.item.values || [];
    const shouldAutoSelect = this.item.autoSelectOnSingle !== false;
    if (shouldAutoSelect && availableOptions.length === 1 && !this.item.value)
    {
      this.item.value = availableOptions[0];
      this.valueChanged(this.item.value);
    }
  },
  methods: {
    valueChanged(event) {
      this.$emit("valueChanged", event);
      this.saving = true;
      this.saved = false;
      EventBus.$emit("form-saving-started");
      this.debouncedSave();
    },
  },
};

</script>
